/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  deleteVideoclipStatus: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.DeleteVideoClipAction.REQUEST_DELETEVIDEOCLIP:
      return {
        ...state,
    };
    case actions.DeleteVideoClipAction.DELETEVIDEOCLIP_RECEIVED:
          return{
      ...state,
      deleteVideoclipStatus: action.data.Status.StatusCode
    };
    case actions.DeleteVideoClipAction.CLEAR_DELETEVIDEOCLIP:
          return{
      ...state,
      deleteVideoclipStatus: null
    };

    default:
      return state;
  }
};

export default reducer;
